module.exports = __webpack_public_path__ + "static/logo-android-dark-8796e56f0d0e0fca2ffb6414f1c93473.svg";